import PropTypes from 'prop-types'
import React from 'react'
import { connect } from 'react-redux'
import { FormattedMessage } from 'react-intl'
import * as bootupSelectors from 'services/bootup/selectors'
import * as authActions from 'services/auth/actions'
import { Button } from 'components/util'
import styles from './_login.css'
import { getWechatLoginUrl } from 'shared/urls'
import { isWechatAuthFromCookies } from 'shared/auth'

const mapStateToProps = state => ({
  wechatApiConfig: bootupSelectors.selectWechatApiConfig(state),
})

const mapDispatchToActions = {
  ...authActions,
}

class WechatLoginButton extends React.Component {

  componentWillMount () {
    if (isWechatAuthFromCookies(document.cookie)) {
      this.props.setWechatAuthState()
      this.props.onLogin({})
    }
  }

  render () {
    return (
      <div className={styles.wechat}>
        <Button
          disabled={this.props.disabled}
          type='wechat'
          icon='wechat_circle'
          className={styles.button}
          onClick={() => {
            window.location.href = getWechatLoginUrl(window, this.props.wechatApiConfig)
          }}>
          <FormattedMessage
            id='auth.login.signin_with_wechat'
            defaultMessage='Log in with Wechat' />
        </Button>
      </div>
    )
  }

}

WechatLoginButton.propTypes = {
  disabled: PropTypes.bool,
  onLogin: PropTypes.func.isRequired,
  setWechatAuthState: PropTypes.func.isRequired,
  wechatApiConfig: PropTypes.object.isRequired,
}

export default connect(mapStateToProps, mapDispatchToActions)(WechatLoginButton)
